// extracted by mini-css-extract-plugin
export default {"chipMenu":"styles_chipMenu__BJV09","cellChipContainer":"styles_cellChipContainer__Uga0-"};